import { camelCase } from "lodash";
import resourceTypes from "../../types/resourceTypes";

const map = {
  [resourceTypes.company]: "companyDetail",
  [resourceTypes.part]: "partDetail",
  [resourceTypes.rma]: "rmaDetail",
  [resourceTypes.incomingQuote]: "incomingQuoteDetail",
  [resourceTypes.inventory]: "inventoryDetail",
  [resourceTypes.lot]: "lotDetail",
  [resourceTypes.outgoingQuote]: "outgoingQuoteDetail",
  [resourceTypes.managedRepairOrder]: "mroDetail",
  [resourceTypes.purchaseOrder]: "purchaseOrderDetail",
  [resourceTypes.receivingRecord]: "receivingRecordDetail",
  [resourceTypes.repairOrder]: "repairOrderDetail",
  [resourceTypes.salesOrder]: "salesOrderDetail",
  [resourceTypes.shipment]: "shipmentDetail"
};

export default function resourceTypeToStateKey(resourceType) {
  return map[resourceType] || `${camelCase(resourceType.slice(0, -1))}Detail`;
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/Notes/resourceToStateKey.js